import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/lib/i18n";

const LangContext = createContext({ lang: "el", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("amazypet_lang") || "el");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("amazypet_lang", l);
  };

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur && cur[p] !== undefined) cur = cur[p];
      else return path;
    }
    return cur;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
